<template>
  <transition name="showMessage">
    <div v-if="shown" id="message">
      <p v-for="(message, index) in messages" :key="`${message}-${index}`">
        {{ message }}
      </p>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Message',
  props: { message: { type: String, default: '' } },
  data() {
    return {
      shown: false,
      messages: [],
    }
  },
  methods: {
    ...mapActions(['sendMessage']),

    displayMessage(text) {
      this.shown = true
      this.messages = this.messages.concat(text.split('\n'))
      this.$nextTick(this.reposDiv)
      window.setTimeout(
        function(currSize) {
          if (this.messages.length === currSize) {
            this.sendMessage('')
            this.messages = []
            this.shown = false
          }
        }.bind(this, this.messages.length),
        5000,
      )
    },
  },
  watch: {
    message(value) {
      if (!value) return

      this.displayMessage(value?.message || value)
    },
  },
}
</script>

<style lang="scss" scoped>
#message {
  position: fixed;
  max-width: calc(100vw - 55px);
  width: fit-content;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);

  padding: 10px;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
  @include tipography(16);
  color: $main-two;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  & p {
    margin: 0;
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.showMessage {
  &-enter-active {
    transition: all 0.5s ease;
  }
  &-leave-active {
    transition: all 0.5s ease;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
